import AdditionalQuestionsTable from "./AdditionalQuestionsTableContainer";

export default AdditionalQuestionsTable;
